import type { Resource } from 'i18next';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next/initReactI18next';

import translationEN from '@/public/locales/en.json';
import translationES from '@/public/locales/es.json';

const resources: Resource = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
